import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "zae_token";

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAuthToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete axios.defaults.headers.common.Authorization;
  }
}

// initialize header from stored token
const _stored = getAuthToken();
if (_stored) axios.defaults.headers.common.Authorization = `Bearer ${_stored}`;

// global 401 handler -> force re-login
axios.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const path = window.location.pathname;
    if (status === 401 && !path.startsWith("/login") && !path.startsWith("/share/")) {
      setAuthToken(null);
      window.location.assign("/login");
    }
    return Promise.reject(err);
  },
);

export const fetcher = (url) => axios.get(`${API}${url}`).then((r) => r.data);
